import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const OffertKategori = lazy(() => import("@/pages/info/OffertKategori"));

export const Route = createFileRoute("/batterier/")({
  head: () => seoHead("/batterier", { description: "Ett hembatteri gör att du kan lagra egenproducerad el och utnyttja prisskillnaderna mellan timmarna. Få kostnadsfria offerter från installatörer." }),
  component: () => <OffertKategori slug="hembatterier" />,
});
